import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { SheetsDisplayGridRowDataFragmentGql } from './SheetsDisplayGridRowFragmentGql';

export const DatabaseDownstreamSheetsFilteredByTableQueryGql: DocumentNode = gql`
query DatabaseDownstreamSheetsFilteredByTableQuery($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowDataFragment
      }
    }
  }
}
${SheetsDisplayGridRowDataFragmentGql}
`;
